<template>
  <div class="section-control section-control-doc">
    <!--展开略缩图部分-->
    <span
      class="section-sidebar cp"
      @click="sidebarToggle"
    >
      <svg class="item-icon">
        <use :xlink:href="showLeft?'#retractLeftcolumn':'#expendLeftcolumn'" />
      </svg>
    </span><!-- 放大缩小部分
    --><div class="section-zoom-area">
            <span
class="zoom-out cp"
@click="zoomOut"
>
                <svg class="item-icon">
                    <use xlink:href="#zoomOut" />
                </svg>
            </span><!--
        --><span
ref="zoomNum"
class="zoom-num"
>{{ zoomNum }}</span><!--
        --><span
class="zoom-in cp"
@click="zoomIn"
>
                <svg class="item-icon">
                    <use xlink:href="#zoomIn" />
                </svg>
            </span>
    </div><!--旋转部分
    --><div
v-if="isPdf"
class="section-rotate-area"
>
            <span
class="rotate-ccw cp"
@click="pageRotateCcw"
>
                <svg class="item-icon">
                    <use xlink:href="#leftRotation" />
                </svg>
            </span><!--
        --><span class="rotate-cw cp">
                <svg
class="item-icon"
@click="pageRotateCw"
>
                    <use xlink:href="#rightRotation" />
                </svg>
            </span>
    </div><!--翻页部分
    --><div class="section-page-area">
            <span
class="page-pre cp"
@click="previous"
>
                <svg class="item-icon">
                    <use xlink:href="#previousOne" />
                </svg>
            </span><!--
        --><input
v-model="pageNum"
type="text"
class="input-num"
@keyup.enter="keyEnter"
><!--
        --><span class="num-delimiter">/</span><!--
        --><co-tips
:content="`${pageNum}/${pagesCount}`"
placement="top"
>
                <span class="total-num">{{ pagesCount }}</span>
            </co-tips><!--
        --><span
class="page-next cp"
@click="next"
>
                <svg class="item-icon">
                    <use xlink:href="#nextOne" />
                </svg>
            </span>
    </div><!-- 全屏
    --><bs-featureguide
v-if="!isIE"
v-model="guideArr[1].isShow"
:guide-text="'全屏查看'"
:guide-key="guideArr[1].guideKey"
:is-auto-run="false"
:guide-width="lang=='en'? 170 : 100"
>
        <span
class="section-fullScreen cp"
@click="presentationMode"
>
            <svg class="item-icon">
                <use :xlink:href="displayFullScreen ? '#iconFullRecovery':'#iconFullScreen'" />
            </svg>
        </span>
       </bs-featureguide>
  </div>
</template>
<script>
import coTips from 'components/common/tips/index.vue'
import {
  requestFullScreen, exitFullscreen, isIE, getLanguage,
} from 'js/util/util'
import bsFeatureguide from 'components/business/featureguide/index.vue'

export default {
  components: {
    coTips,
    bsFeatureguide,
  },
  props: {
    // 预览返回的要预览文件的路径
    src: {
      type: String,
      default: '',
    },
    // fileData文件信息
    fileData: {
      type: Object,
      default() {
        return {}
      },
    },
    isSmartShare: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pageNum: 0, // 当前页码,可视区域最大显示6位数
      showLeft: false, // 默认不显示左侧
      setIntervalId: '',
      displayFullScreen: false,
    }
  },
  computed: {
    /**
             * 是否为ie
             */
    isIE() {
      return isIE()
    },
    /**
             * 当前语言
             */
    lang() {
      return getLanguage()
    },
    guideArr() {
      return this.$store.state.guideArr
    },
    /**
             * 当前pdf的信息
             */
    previewInfo() {
      return this.$store.state.previewInfo
    },
    /**
             * 总页数
             *
             */
    pagesCount() {
      const counts = this.checkPdfObj('pagesCount')
      return counts || 0
    },
    /**
             * 当前缩放比例
             */
    zoomNum() {
      const pv = this.checkPdfObj('toolbar')
      if (pv && pv.pageScale) {
        return `${Math.floor(pv.pageScale * 100)}%`
      }
      return '100%'
    },
    /**
             * 判断是否为pdf如果为pdf那么会有旋转按钮
             */
    isPdf() {
      const metaData = this.$store.state.curFileInfo
      const mimeType = metaData.mime_type || ''
      if (mimeType.indexOf('.pdf') != -1) {
        return true
      }
      return false
    },
    /**
             * 读取pdfjs当前的页数
             */
    page() {
      return this.checkPdfObj('page')
    },
  },
  watch: {
    /**
             * 监听当前页数的变化
             */
    pageNum(val, oldVal) {
      if (val) {
        const reg = /^[0-9]*[1-9][0-9]*$/
        if (reg.test(val)) { // 对输入的数进行判断，是否符合正整数的规范
          const num = val.toString().split('') && val.toString().split('').length
          if (num > 4) { // 大于4位数，扩大输入框宽度
            document.querySelector('.input-num').style.width = '52px'
          } else { // 还原
            document.querySelector('.input-num').style.width = '38px'
          }
          if (val < 1 || (this.pagesCount > 0 && val > this.pagesCount)) { // 判断输入页码范围
            this.pageNum = oldVal
          }
          // 当页数变化加入smartshare的逻辑 -by wrl
          if (this.isSmartShare) {
            this.$emit('pagechange', {
              opage: oldVal,
              cpage: val,
              tpage: this.pagesCount,
            })
          }
        } else {
          this.pageNum = oldVal
        }
      }
    },
    /**
             * 监听读取的pdfjs当前的页数变化
             */
    page(val, oldVal) {
      this.pageNum = val
    },
    fileData: {
      handler(n, o) {
        this.showLeft = false
        // clearInterval(this.setIntervalId)
        // // 如果是ppt,非幻灯片模式 或者pdf
        // if (!n) { return }
        // let isPpt = /ppt|dps/i.test(this.fileData.mime_type)
        // let isPdf = /pdf/i.test(this.fileData.mime_type)

        // //设置循环
        // this.setIntervalId = setInterval(() => {
        //     let pinfo = this.previewInfo
        //     if (pinfo) {
        //         clearInterval(this.setIntervalId)
        //         //console.log(pinfo.pdfSidebar.visibleView, 'visibleView')
        //         //首次加载文件资源
        //         if (pinfo.pdfSidebar && !pinfo.pdfSidebar.visibleView) {
        //             let isSlide = pinfo && pinfo.pdfSidebar.visibleView || 0
        //             if (((isPpt && !this.$store.state.isSideMode) || isPdf) && isSlide == 0 && !this.showLeft) {
        //                 console.log('click...')
        //                 setTimeout(() => {
        //                     this.sidebarToggle()
        //                     this.showLeft = true
        //                 }, 1000)
        //             }
        //         }
        //     }
        // }, 1000)
      },
      immediate: true,
    },
    /**
             * 监听总页数变化，smartshare会用到（解决不能及时获取总页数问题）
             */
    pagesCount: {
      handler(nval, oval) {
        // 当页数变化加入smartshare的逻辑 -by wrl
        if (this.isSmartShare) {
          this.$emit('pagesCount', nval)
        }
      },
    },
  },
  mounted() {
    window.addEventListener('resize', this.pushEsc)
    window.addEventListener('message', this.messageHandler)
  },
  destroyed() {
    window.removeEventListener('message', this.messageHandler)
  },
  methods: {
    /**
             * 设置码
             */
    setPage(n) {
      try {
        document.getElementById('pdfframe').contentWindow.PDFViewerApplication.page = n
      } catch (e) {
        console.log(e)
      }
    },
    /**
             * 键盘回车事件用于跳页
             */
    keyEnter(e) {
      const n = parseInt(e.target.value)
      this.setPage(n)
    },
    /**
             * 侧边栏显示隐藏
             */
    sidebarToggle() {
      this.showLeft = !this.showLeft
      this.getPdfWin().document.getElementById('sidebarToggle').click()
    },
    /**
             * 放大
             */
    zoomIn() {
      this.getPdfWin().document.getElementById('zoomIn').click()
      this.displayToast()
    },
    /**
             * 缩小
             */
    zoomOut() {
      this.getPdfWin().document.getElementById('zoomOut').click()
      this.displayToast()
    },
    /**
             * 展示toast，当在小屏时，隐藏zoomNum，并在按zoomOut and zoomIn时，toast提示
             */
    displayToast() {
      if (this.$refs.zoomNum && window.getComputedStyle(this.$refs.zoomNum).display === 'none') {
        // 弹窗提示错误信息
        this.$toast.originToast({
          toastInfo: { info: `${this.$t('显示比例')}: ${this.zoomNum}`, tipsType: 'notice' },
          value: true,
          show: true,
          isIcon: false,
        })
      }
    },
    /**
             * 顺时针旋转
             */
    pageRotateCw() {
      this.getPdfWin().document.getElementById('pageRotateCw').click()
    },
    /**
             * 逆时针旋转
             *
             */
    pageRotateCcw() {
      this.getPdfWin().document.getElementById('pageRotateCcw').click()
    },
    /**
             * 上一页
             */
    previous() {
      this.getPdfWin().document.getElementById('previous').click()
    },
    /**
             * 下一页
             */
    next() {
      this.getPdfWin().document.getElementById('next').click()
    },
    /**
             * 全屏
             */
    presentationMode() {
      const me = this
      !me.displayFullScreen ? requestFullScreen() : exitFullscreen()
      me.$nextTick(() => {
        me.displayFullScreen = !me.displayFullScreen
        me.$emit('presentationMode', me.displayFullScreen)
      })
    },
    /**
             * 检查pdf对象属性是否有值
             */
    checkPdfObj(attr) {
      const obj = this.$store.state.previewInfo
      if (obj && obj[attr]) {
        if (attr === 'toolbar') {
          return { ...obj[attr] }
        }
        return obj[attr]
      }
      return ''
    },
    /**
             * 获取pdfdocument对象
             */
    getPdfWin() {
      if (document.getElementById('pdfframe') && document.getElementById('pdfframe').contentWindow) {
        return document.getElementById('pdfframe').contentWindow
      }
    },
    /**
             * 校验是否为全屏
             */
    checkFull() {
      // console.log(document.fullscreenEnabled,"=========", window.fullScreen,"=========", document.webkitIsFullScreen,"=========", document.msFullscreenEnabled)
      // var isFull = document.fullscreenEnabled || window.fullScreen || document.webkitIsFullScreen || document.msFullscreenEnabled
      // let isFull = window.fullScreen || document.webkitIsFullScreen || document.msFullscreenEnabled
      // if (isFull === undefined) isFull = false
      // return isFull
      return document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen
    },
    /**
             * 按esc键退出全屏
             */
    pushEsc() {
      if (!this.checkFull()) {
        this.displayFullScreen = false
      }
    },
    /**
             * postMessage的callback
             */
    messageHandler(e) {
      if (e.data && e.data.type === 'sideView') { // pdfjs中的初始化sidebar
        this.sideViewHandler(e.data.data)
      }
    },
    /**
             * 处理pdf和ppt格式文件默认展开左侧栏
             * @params {Number} data pdfjs中关于左侧栏展开如何取值，如下：0为不展开
             * ATTACHMENTS: 3
             * NONE: 0
             * OUTLINE: 2
             * THUMBS: 1
             */
    sideViewHandler(data) {
      const isPpt = /ppt|dps/i.test(this.fileData.mime_type)
      const isPdf = /pdf/i.test(this.fileData.mime_type)
      const isSideBarOpen = data != 0
      // console.log('sidebar', isSideBarOpen, this.showLeft)
      if ((isPpt && this.$store.state.isSideMode) || isPdf) {
        this.showLeft = true // 底部toolbar显示打开左侧栏
        if (!isSideBarOpen) {
          this.getPdfWin().document.getElementById('sidebarToggle').click()
        }
      } else {
        this.showLeft = false // 底部toolbar显示关闭左侧栏
        if (isSideBarOpen) {
          this.getPdfWin().document.getElementById('sidebarToggle').click()
        }
      }
    },
  },
}
</script>
<style lang="less">
</style>
